import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '@/auth/Login';
import SignIn from '@/auth/SignIn';
import NotAuthorized from '@/auth/NotAuthorized';

import SetsMainPage from '@/components/Prüfungsset/SetsMainPage';
import SingleSetPage from '@/components/Prüfungsset/SingleSetPage';
import CreateSetPage from '@/components/Prüfungsset/CreateSetPage';
import EditSetPage from '@/components/Prüfungsset/EditSetPage';

import CreatePruefungsstueckPage from '@/components/Prüfungsstück/CreatePruefungsstueckPage';
import EditPruefungsstueckPage from '@/components/Prüfungsstück/EditPruefungsstueckPage';

import ExamMainPage from '@/components/Prüfung/ExamMainPage';
import AddExamPage from '@/components/Prüfung/AddExamPage';

import VersendungMainPage from '@/components/Versendung/VersendungMainPage';

import EinsatzMainPage from '@/components/Einsatz/EinsatzMainPage';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: SetsMainPage
        },
        {
            path: '/login',
            component: Login
        },
        {
            path: '/signin',
            component: SignIn
        },
        {
            path: '/sets',
            name: 'SetsMainPage',
            component: SetsMainPage
        },
        {
            path: '/sets/create',
            name: 'CreateSet',
            component: CreateSetPage
        },
        {
            path: '/sets/:setId',
            name: 'SingleSet',
            component: SingleSetPage,
            props: true
        },
        {
            path: '/sets/:setId/edit',
            name: 'EditSet',
            component: EditSetPage,
            props: true
        },
        {
            path: '/ps/create',
            name: 'CreatePrüfungsstück',
            component: CreatePruefungsstueckPage
        },
        {
            path: '/ps/:psId/edit',
            name: 'EditPrüfungsstück',
            component: EditPruefungsstueckPage,
            props: true
        },
        {
            path: '/exam',
            component: ExamMainPage
        },
        {
            path: '/exam/add',
            name: 'addExam',
            component: AddExamPage
        },
        {
            path: '/versendung',
            component: VersendungMainPage
        },
        {
            path: '/einsatz',
            component: EinsatzMainPage
        },
        {
            path: '/not-authorized',
            component: NotAuthorized
        }
    ]
});

router.beforeEach((to, from, next) => {
    console.log('before going to', to.path);
    var azureAd = router.app.$azure;

    if (azureAd.isLoggedIn()) {
        console.log('is logged in');

        if (azureAd.isLoginExpired()) {
            console.log('login expired');

            azureAd.refreshToken(
                () => next(),
                () => {
                    azureAd.logout(() => next());
                }
            );
        } else {
            if (to.path !== '/not-authorized') {
                azureAd.getUserGroups().then(gr => {
                    console.log('received groups');
                    console.log(gr);

                    if (azureAd.isInGroup(gr, 'taz-ps-pflege')) {
                        next();
                    } else {
                        console.error('user is not authorized');
                        next({ path: '/not-authorized' });
                    }
                });
            } else {
                next();
            }
        }
    } else if (to.path === '/login' || to.path === '/signin') {
        console.log('trying to login or handling signin');
        next();
    } else {
        console.log(
            'not logged in and not attempting to do so... redirect to login'
        );
        next({ path: '/login' });
    }
});

Vue.router = router;

export default router;
